import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { PropsWithChildren } from 'react'

interface Props {
  m?: number;
  mb?: number;
  mt?: number;
  ml?: number;
  mr?: number;
  p?: number;
  pb?: number;
  pt?: number;
  pl?: number;
  pr?: number;
  mSm?: number;
  mbSm?: number;
  mtSm?: number;
  mlSm?: number;
  mrSm?: number;
  pSm?: number;
  pbSm?: number;
  ptSm?: number;
  plSm?: number;
  prSm?: number;
}

/**
 * @deprecated
 * A component for applying arbitrary margin/padding.
 *
 * A better pattern is for a parent element to apply spacing between its children.
 * Should be using `VerticalSpacer`, 'Group' or `HorizontalSpacer` instead of this.
*/
const Spacing = styled.div<PropsWithChildren<Props>>`
  ${({ m }) => m && `margin: ${rem(m)}`};
  ${({ mb }) => mb && `margin-bottom: ${rem(mb)}`};
  ${({ mt }) => mt && `margin-top: ${rem(mt)}`};
  ${({ ml }) => ml && `margin-left: ${rem(ml)}`};
  ${({ mr }) => mr && `margin-right: ${rem(mr)}`};

  ${({ p }) => p && `padding: ${rem(p)}`};
  ${({ pb }) => pb && `padding-bottom: ${rem(pb)}`};
  ${({ pt }) => pt && `padding-top: ${rem(pt)}`};
  ${({ pl }) => pl && `padding-left: ${rem(pl)}`};
  ${({ pr }) => pr && `padding-right: ${rem(pr)}`};

  ${mediaQueryUp.tablet} {
    ${({ mSm }) => mSm && `margin: ${rem(mSm)}`};
    ${({ mbSm }) => mbSm && `margin-bottom: ${rem(mbSm)}`};
    ${({ mtSm }) => mtSm && `margin-top: ${rem(mtSm)}`};
    ${({ mlSm }) => mlSm && `margin-left: ${rem(mlSm)}`};
    ${({ mrSm }) => mrSm && `margin-right: ${rem(mrSm)}`};

    ${({ pSm }) => pSm && `padding: ${rem(pSm)}`};
    ${({ pbSm }) => pbSm && `padding-bottom: ${rem(pbSm)}`};
    ${({ ptSm }) => ptSm && `padding-top: ${rem(ptSm)}`};
    ${({ plSm }) => plSm && `padding-left: ${rem(plSm)}`};
    ${({ prSm }) => prSm && `padding-right: ${rem(prSm)}`};
  }
`

export default Spacing
